// extracted by mini-css-extract-plugin
module.exports = {"button":"link_button_button__2XtF6"};